module.exports = __webpack_public_path__ + "img/no-image.df3e0969.jpg";